import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard, UserCheck, FolderOpen, UsersRound, BarChart3, LogOut, Shield, ShieldCheck
} from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import toast from 'react-hot-toast';

const links = [
  { to: '/dashboard', label: 'Dashboard',     icon: LayoutDashboard },
  { to: '/kyc',       label: 'KYC Management',icon: ShieldCheck },
  { to: '/admins',    label: 'Manage Admins', icon: ShieldCheck },
  { to: '/owners',    label: 'Manage Owners', icon: UserCheck },
  { to: '/groups',    label: 'View Groups',   icon: FolderOpen },
  { to: '/members',   label: 'View Members',  icon: UsersRound },
  { to: '/stats',     label: 'System Stats',  icon: BarChart3 },
];

const Sidebar = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-[#1A2535] flex flex-col shadow-xl z-30">
      {/* Logo */}
      <div className="px-6 py-6 border-b border-gray-800">
        <div className="flex items-center gap-3">
          <div className="bg-teal-500/20 p-2 rounded-xl">
            <Shield size={22} className="text-teal-400" />
          </div>
          <div>
            <h1 className="text-white font-bold text-lg leading-tight">Digital Bhishi</h1>
            <p className="text-teal-400 text-xs font-medium uppercase tracking-wide">Super Admin</p>
          </div>
        </div>
      </div>

      {/* Nav links */}
      <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
        {links.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 ${
                isActive 
                  ? 'bg-teal-500 text-white shadow-lg shadow-teal-500/30' 
                  : 'text-gray-400 hover:bg-gray-800 hover:text-white'
              }`
            }
          >
            <Icon size={20} />
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer / Logout */}
      <div className="p-4 border-t border-gray-800">
        <button
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-red-500/10 hover:bg-red-500 hover:text-white text-red-500 rounded-xl font-semibold transition-all duration-200"
        >
          <LogOut size={18} />
          Sign Out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
